  <template>
  <div>
    <div>
      <el-form
        inline
        size="mini"
        label-width="74px"
        class="table-search-part more-search-part inline-wrapper"
        @submit.native.prevent="handleQuery()"
      >
        <div class="search-left order-search-left">
          <el-form-item label="Order Time">
            <el-date-picker
              v-model="orderTime"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              @change="orderDate"
              type="daterange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Order ID">
            <el-input
              type="number"
              @mousewheel.native.prevent
              v-model="ordersId"
              placeholder="Order ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="statusId" placeholder="Status" :popper-append-to-body="false">
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bet Type">
            <el-select
              v-model="queryData.seriesType"
              placeholder="Bet Type"
              :popper-append-to-body="false"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in betTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Match ID">
            <el-input
              type="number"
              @mousewheel.native.prevent
              v-model="matchsId"
              placeholder="Match ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="IP">
            <el-input v-model="queryData.ip" placeholder="IP"></el-input>
          </el-form-item>
          <el-form-item label="Order Risk Tag" label-width="105px">
            <el-select 
              v-model="queryData.riskTagIds" 
              placeholder="Order Risk Tag" 
              :popper-append-to-body="false"
              filterable
              collapse-tags
              multiple
            >
              <el-option
                v-for="item in riskTagList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Settlement Time" v-if="allSearchVisible">
            <el-date-picker
              v-model="settleTime"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              @change="settleDate"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Match Type" v-if="allSearchVisible">
            <el-select
              v-model="matchType"
              placeholder="Match Type"
              clearable
              @change="handleMatchTypeChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in matchTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sport" v-if="allSearchVisible">
            <el-select
              v-model="sportId"
              filterable
              placeholder="Sport"
              :popper-append-to-body="false"
              @change="getSport(sportId)"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in sportList"
                :key="Number(item.code)"
                :label="item.value"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Market" v-if="allSearchVisible">
            <el-select
              v-model="queryData.marketTypes"
              multiple
              collapse-tags
              placeholder="Market"
              :popper-append-to-body="false"
              @click.native="getMarketList()"
            >
              <el-option
                v-for="(item,index) in marketList"
                :key="index"
                :label="item.marketName"
                :value="item.marketType"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Period" v-if="allSearchVisible">
            <el-select
              v-model="queryData.period"
              multiple
              collapse-tags
              placeholder="Period"
              :popper-append-to-body="false"
              @click.native="getPeriodList()"
            >
              <el-option
                v-for="(item,index) in periodList"
                :key="index"
                :label="item.value"
                :value="item.code*1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Match Status" v-if="allSearchVisible">
            <el-select
              v-model="queryData.isInplay"
              placeholder="Match Status"
              clearable
              :popper-append-to-body="false"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in matchStateList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Order Lock">
            <el-select
              v-model="queryData.lock"
              placeholder="Order Lock"
              :popper-append-to-body="false"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in lockList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Early Payout">
            <el-select
              v-model="queryData.promotionResult"
              placeholder="Early Payout"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in payoutList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="search-right inline-right order-search-right middle-btn">
          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          <el-button class="clear-btn" @click="handleClearQuery()">Clear</el-button>
          <el-button class="more-btn" @click="getAllSearch()">
            More
            <i :class="allSearchVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button class="lebel-risk-export-btn" id="download" @click="handleExport()">
            <i class="icon iconfont iconProperty1xiazai"></i>
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="order-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Order ID" prop="orderId" min-width="155px"></el-table-column>
        <el-table-column label="Order Time/Status" min-width="156px">
          <template v-slot="{row}">
            <div v-if="row.orderTime">{{ formatUtc(row.orderTime) }}</div>
            <div style="display: flex;align-items: center;">
              <div v-for="(item, index) in statusList" :key="index">
                <span
                  v-if="row.status == item.id"
                  :class="{'text-blue':row.status == 4,'text-green':row.status == 5}"
                >{{ item.label }}</span>
              </div>
              <el-tooltip class="item" effect="dark" placement="top" v-if="row.rollBackCount >  0">
                <div slot="content">Rolled back: {{ row.rollBackCount }}</div>
                <img
                  v-if="row.rollBackCount >  0"
                  style="margin:0 10px"
                  width="16"
                  height="16"
                  src="@/assets/img/rollBack-icon.png"
                  alt
                />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Bet Type" min-width="70">
          <template v-slot="{row}">
            <div v-if="row.allUp == 1">Single</div>
            <div v-if="row.allUp != 1">
              <p>Parlay</p>
              <p>{{row.betType}}</p>
            </div>
            <div :class="['red',{'red-flag': row.riskFlagName }]">{{row.riskFlagName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Match" min-width="300px">
          <template v-slot="{ row }">
            <div v-for="(item, index) in row.betDetail" :key="index" class="table-td-item match">
              <p>
                {{item.sportName}}
                <span v-if="item.matchId" class="matchId">{{item.matchId}}</span>
                {{formatUtc(item.beginTime)}}
              </p>
              <p class="home-away" @click="handleChange(row.orderTime,item.matchId)">
                {{item.home}}
                <span v-if="item.home && item.away">VS</span>
                {{item.away}}
              </p>
              <p>{{item.leagueName}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Bet Details" min-width="220px">
          <template v-slot="{row}">
            <div v-for="(item,index) in row.betDetail" :key="index" class="table-td-item detail">
              <div>
                <div>
                  {{ item.optionName }}
                  <span>
                    / @
                    <el-button
                      type="text"
                      class="text-blue"
                      @click="showDialog(false,2,row.orderTime,item)"
                    >{{item.betOdds}} ({{feachOdds(row.betDetail[0].oddsFormat)}})</el-button>
                  </span>
                </div>
                <p>
                  <span v-if="item.matchType !== 1 && item.matchType !== 4 && item.matchType !== 5">
                    <span v-if="item.isInplay" class="text-red">Live</span>
                    <span v-if="!item.isInplay" class="text-red">PreMatch</span>
                  </span>
                  <span>{{ item.periodName }}</span>
                  <span>
                    {{ item.marketName }}
                    <span v-if="item.extraInfo">({{item.extraInfo}})</span>
                  </span>
                  <br />
                  <span>{{ item.betScore }}</span>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="EUR Odds" min-width="90px">
          <template v-slot="{row}">
            <div v-if="row.allUp == 1">
              <el-button type="text" class="text-blue">@{{row.betDetail[0].odds}}</el-button>
            </div>
            <div
              v-if="row.allUp != 1"
              class="odds"
            >@ {{odds(row.maxWinAmount,row.stakeAmount,row.betNum)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Result/Early Win" min-width="150px">
          <template v-slot="{row}">
            <div v-for="(item,index) in row.betDetail" :key="index" class="table-td-item result">
              <p class="result-text" v-if="item.settleResult == 7">
                <span>.</span>Cancel
              </p>
              <p class="text-blue result-text" v-if="item.settleResult == 2">
                <span>.</span>Push
              </p>
              <p class="text-green result-text" v-if="item.settleResult == 3">
                <span>.</span>Loss
              </p>
              <p class="text-red result-text" v-if="item.settleResult == 4">
                <span>.</span>Win
              </p>
              <p class="text-red result-text" v-if="item.settleResult == 5">
                <span>.</span>WinReturn
              </p>
              <p class="text-green result-text" v-if="item.settleResult == 6">
                <span>.</span>LossReturn
              </p>
              <p v-if="item.matchResult">Result {{item.matchResult}}</p>
              <p>{{item.cancelReasonValue}}</p>
              <p class="text-red" v-if="item.promotionResult == 1">Early Win</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Company Win/Loss" prop="profit" min-width="130px">
          <template v-slot="{row}">
            <div>
              <div
                :class="{'text-red': Math.sign(row.profit) == 1,'text-green':Math.sign(row.profit) == -1}"
              >{{formatAmountHtml(formatMoney(Number(row.profit)*Number(row.exchangeRate)))}}</div>
              <div
                v-if="row.currency != 1 && row.profit != 0"
                :class="{'text-red': Math.sign(row.profit) == 1,'text-green':Math.sign(row.profit) == -1}"
              >
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{formatAmountHtml(row.profit)}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="IP" min-width="186px">
          <template v-slot="{ row }">
            <div>{{row.terminal}}</div>
            <div :class="[{'ipStatus': row.ipStatus === 3}]">{{row.ip}}</div>
            <div>{{row.region}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Stake" prop="stakeAmount" min-width="105px">
          <template v-slot="{row}">
            <div>
              <div>{{formatAmountHtml(formatMoney(row.stakeAmount*row.exchangeRate))}}</div>
              <div v-if="row.currency != 1 && row.stakeAmount != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{formatAmountHtml(row.stakeAmount)}}</span>
              </div>
            </div>
            <div
              v-if="row.companyPercentage"
              style="transform:scale(0.8);position: relative;left: -8px;"
            >{{row.companyPercentage * 100}}%</div>
          </template>
        </el-table-column>
        <el-table-column label="Settle Stake" prop="settleStake" min-width="105px">
          <template v-slot="{row}">
            <div>
              <div>{{formatAmountHtml(formatMoney(row.settleStake*row.exchangeRate))}}</div>
              <div v-if="row.currency != 1 && row.settleStake != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{formatAmountHtml(row.settleStake)}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Settle Return" prop="settleReturn" min-width="97px">
          <template v-slot="{row}">
            <div>
              <div>{{formatAmountHtml(formatMoney(row.settleReturn*row.exchangeRate))}}</div>
              <div v-if="row.currency != 1 && row.settleReturn != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{formatAmountHtml(row.settleReturn)}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Cashout Stake" min-width="110px">
          <template v-slot="{ row }">
            <div
              :class="[row.cashoutStake!=0?'text-blue':'text-grey']"
              style="cursor: pointer;"
              @click="showDialog(row,1)"
            >
              <!-- {{row.cashoutStake}} -->
              <div>
                <div>{{formatAmountHtml(formatMoney(row.cashoutStake*row.exchangeRate))}}</div>
                <div v-if="row.currency != 1 && row.cashoutStake != 0" style="color: #999;">
                  <span>{{row.currencyCode}}&nbsp;</span>
                  <span>{{formatAmountHtml(row.cashoutStake)}}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Cashout Return" prop="cashoutPayout" min-width="112px">
          <template v-slot="{row}">
            <div>
              <div>{{formatAmountHtml(formatMoney(row.cashoutPayout*row.exchangeRate))}}</div>
              <div v-if="row.currency != 1 && row.cashoutPayout != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{formatAmountHtml(row.cashoutPayout)}}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Settlement Time" min-width="130px">
          <template v-slot="{row}">
            <div v-if="row.settleTime">{{ formatUtc(row.settleTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Risk Tag" min-width="130px">
          <template v-slot="{row}">
            <div v-if="row.riskTags">{{ (row.riskTags || []).join(',') }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Order Lock History" min-width="250px">
          <template v-slot="{row}">
            <div v-if="row.lock">{{ row.lock == 1 ? 'Lock' : 'Unlock' }}, {{ formatUtc(row.lockLastTime) }}（{{ row.lockLastOperatorName }}）</div>
          </template>
        </el-table-column>
        <el-table-column label="Pending Event" min-width="120px">
          <template v-slot="{row}">
            <div v-for="(item,index) in row.betDetail" :key="index" class="table-td-item result">
              <p>{{item.event}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom">
      <!-- cashout1 -->
      <div v-if="num == 1">
        <div class="cashout-header">
          Cashout Detail
          <span class="cashout-header-count">Cashout Count: {{cashoutCount}}</span>
        </div>
        <el-table :data="cashoutList" :key="1" v-loading="dialogLoading">
          <el-table-column prop="orderId" label="Cashout Order ID"></el-table-column>
          <el-table-column label="Cashout Time">
            <template v-slot="{row}">
              <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cashOutStake" label="Cashout Stake">
            <template v-slot="{ row }">
              <div>{{ formatAmountHtml(row.cashOutStake) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cashOutPayoutStake" label="Cashout Payout"></el-table-column>
          <el-table-column prop="cashoutProfit" label="Cashout Profit"></el-table-column>
          <el-table-column label="Cashout Order Status" width="120">
            <template v-slot="{ row }">
              <span v-for="(item, index) in statusList" :key="index">
                <span v-if="row.orderStatus == item.id">{{ item.label }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 赔率2 -->
      <div v-if="num == 2" class="dialog-odd-wrapper">
        <div class="dialog-more">
          <div class="dialog-more-item">
            <el-form
              inline
              size="mini"
              label-width="70px"
              class="table-search-part more-search-part inline-wrapper"
            >
              <el-form-item label="Forward access time">
                <el-input
                  type="number"
                  @mousewheel.native.prevent
                  v-model="forwardAccessTime"
                  v-on:input="handleForwardAccessTime"
                  placeholder="5"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button class="dialog-more-btn" @click="handleTimeClick('5')">5minutes</el-button>
            <el-button class="dialog-more-btn" @click="handleTimeClick('15')">15minutes</el-button>
            <el-button class="dialog-more-btn" @click="handleTimeClick('60')">60minutes</el-button>
          </div>
          <div class="dialog-more-item">
            <el-form
              inline
              size="mini"
              label-width="70px"
              class="table-search-part more-search-part inline-wrapper"
            >
              <el-form-item label="Future access time">
                <el-input
                  type="number"
                  @mousewheel.native.prevent
                  v-model="futureAccessTime"
                  v-on:input="handleFutureAccessTime"
                  placeholder="5"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="dialog-more-btn" @click="moreOddsList()">Search</el-button>
          </div>
        </div>
        <el-table
          :data="oddsList"
          :key="2"
          border
          :row-style="isRed"
          v-loading="dialogLoading"
          :height="500"
        >
          <el-table-column label="Time" width="180">
            <template v-slot="{row}">
              <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="odds" label="Odds" width="80"></el-table-column>
          <el-table-column prop="difference" label="Difference"></el-table-column>
          <el-table-column
            v-for="bookmaker in bookmakers"
            :key="bookmaker.prop"
            :label="bookmaker.label"
            :prop="bookmaker.prop"
          >
            <template slot-scope="{ row }">
              <span v-for="(odds,index) in row.bookmakerOddsList" :key="index">
                <span
                  v-if="odds.bookmaker == bookmaker.prop"
                >{{ odds.odds == '-1' ? '/' : odds.odds }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="oddsTotal"
            :current-page="oddsQueryData.current"
            :page-size="oddsQueryData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeOddsPage"
            @size-change="handleSizeOddsChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </div>
    </dia>
    <dia ref="dialogDomName" class="label-dialog">
      <eventList :eventMatchId="eventMatchId" :eventTime="eventTime" />
    </dia>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { formatAmount } from "@/utils";
import dia from "@/components/dialog/index";
import eventList from "@/components/event/index";
import Empty from "@/components/empty/index";
import {
  getRiskTagList,
} from "@/api/orderRiskTag";

import {
  getOrderList,
  getExport,
  getTcsSportList,
  getMarketList,
  getPeriodList,
  getCashoutList,
  getOddsList
} from "@/api/memberDetail";
export default {
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      riskTagList: [],
      loading: false,
      dialogLoading: false,
      total: 0,
      queryData: {
        ip: "",
        riskTagIds: [],
        userIds: [],
        seriesType: "",
        orderStartTime: "",
        orderEndTime: "",
        settleStartTime: "",
        settleEndTime: "",
        orderIds: [],
        orderStatus: [],
        sportIds: [],
        matchIds: [],
        marketTypes: [],
        result: [],
        isInplay: "",
        matchTypes: [],
        period: [],
        timeZoneOffset: "",
        current: 1,
        size: 50,
        lock: "",
        promotionResult: "",
      },
      cashoutQueryData: {
        orderId: 0,
        orderStatus: 0
      },
      oddsTotal: 0,
      matchType: '',
      forwardAccessTime: 5,
      futureAccessTime: 5,
      accessTime: "",
      oddsQueryData: {
        beginTime: "",
        endTime: "",
        odds: 0,
        matchId: 0,
        marketId: 0,
        period: 0,
        optionType: 0,
        current: 1,
        size: 50
      },
      marketQueryData: {
        sportIds: []
      },
      ordersId: "",
      matchsId: "",
      statusId: "",
      sportId: "",
      tableHeight: window.innerHeight,
      orderTime: [],
      settleTime: [],
      matchStateList: [
        {
          id: false,
          label: "Pre-Match"
        },
        {
          id: true,
          label: "Live"
        }
      ],
      matchTypeList: [
        {
          id: 1,
          label: "Outright"
        },
        {
          id: 2,
          label: "Match"
        },
        {
          id: 4,
          label: "VR sport"
        },
        {
          id: 3,
          label: "Esports"
        },
        {
          id: 5,
          label: "Esports Outright"
        }
      ],
      resultList: [
        {
          id: 2,
          label: "Loss"
        },
        {
          id: 1,
          label: "Win"
        }
      ],
      statusList: [
        {
          id: 0,
          label: "Created"
        },
        {
          id: 1,
          label: "Confirming"
        },
        {
          id: 2,
          label: "Rejected"
        },
        {
          id: 3,
          label: "Canceled"
        },
        {
          id: 4,
          label: "Confirmed"
        },
        {
          id: 5,
          label: "Settled"
        }
      ],
      betTypeList: [
        {
          id: 0,
          label: "Single"
        },
        {
          id: 1,
          label: "Parlay"
        }
      ],
      lockList: [
        {
          id: 1,
          label: "Locked"
        },
        {
          id: 2,
          label: "Unlocked"
        }
      ],
      payoutList: [
        {
          id: 0,
          label: "Eligible"
        },
        {
          id: 1,
          label: "Early Win"
        }
      ],
      num: "",
      eventMatchId: "",
      eventTime: "",
      sportList: [],
      marketList: [],
      periodList: [],
      oddsList: [],
      bookmakers: [
        { prop: "11001", label: "188 Odds" },
        { prop: "14001", label: "IBC Odds" },
        { prop: "12001", label: "365 Odds" }
      ],
      cashoutList: [],
      cashoutCount: 0,
      allSearchVisible: false,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: time => {
          if (this.curDate) {
            const one = 90 * 24 * 3600 * 1000;
            const minTime = this.curDate - one;
            const maxTime = this.curDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      }
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    handleMatchTypeChange(val) {
      // 你的列表查询里用的是 queryData.matchTypes，这里同步一下（可选）
      if (val) {
        this.queryData.matchTypes = [val];
      } else {
        this.queryData.matchTypes = [];
      }
      // 切换类型后，期数选项可能变化，清空已选 period
      this.queryData.period = [];
      // 重新拉取 period 列表（会把 matchType 一起传给后端）
      //this.getPeriodList();
    },
    async getRiskTagList() {
      this.loading = true;
      try {
        const res = await getRiskTagList();
        const data = res.data || [];
        this.riskTagList = data
        // this.total = data.total;
      } catch (error) {
        this.riskTagList = [];
      }
    },
    formatAmountHtml(value) {
      // return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let amount = Number(value).toFixed(2);
      amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return amount;
    },
    orderDate(val) {
      if (val != null) {
        const [startTime, endTime] = val;
        this.queryData.orderStartTime = startTime;
        this.queryData.orderEndTime = endTime;
      } else {
        this.queryData.orderStartTime = "";
        this.queryData.orderEndTime = "";
      }
    },
    handleChange(time, id) {
      if (!time) {
        this.$message({
          message: "OrderTime Cannot Be Empty ",
          type: "warning"
        });
        return;
      }
      if (!id) {
        this.$message({
          message: "MatchId Cannot Be Empty ",
          type: "warning"
        });
        return;
      }
      this.title = "Event List";
      this.eventTime = Number(time);
      this.eventMatchId = Number(id);
      this.$refs["dialogDomName"].isShowDia(this.title, true, "1400px");
    },
    Close() {
      this.$refs["dialogDomName"].isShowDia(this.title, false, "1400px");
    },
    settleDate(val) {
      if (val != null) {
        const [startTime, endTime] = val;
        this.queryData.settleStartTime = startTime;
        this.queryData.settleEndTime = endTime;
      } else {
        this.queryData.settleStartTime = "";
        this.queryData.settleEndTime = "";
      }
    },
    async getList() {
      this.queryData.orderStatus = [];
      if (this.statusId !== "") {
        this.queryData.orderStatus.push(this.statusId);
      }
      // 处理 matchTypes，保证是数组格式
      if(this.matchType){
        this.queryData.matchTypes = [this.matchType];
      }else{
        this.queryData.matchTypes = [];
      }
      this.queryData.userIds = this.$route.query.userId
        ? this.$route.query.userId
            .toString()
            .replace(/\s+/g, "")
            .split(",")
        : [];
      this.queryData.matchIds = this.matchsId
        ? this.matchsId.replace(/\s+/g, "").split(",")
        : [];
      this.queryData.orderIds = this.ordersId
        ? this.ordersId.replace(/\s+/g, "").split(",")
        : [];
      this.queryData = this.deleteEmptyQuery(this.queryData);
      this.loading = true;
      try {
        const res = await getOrderList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || [];
        this.sportList = data;
      } catch (error) {
        this.sportList = [];
      }
    },
    async getMarketList() {
      if (!this.queryData.sportIds) {
        this.$message({
          message: "Must checked sport first",
          type: "warning"
        });
      } else {
        try {
          const res = await getMarketList(this.marketQueryData.sportIds);
          const data = res.data || {};
          this.marketList = data || [];
        } catch (error) {
          this.marketList = [];
        }
      }
    },
    async getPeriodList() {
      if (!this.queryData.sportIds || this.queryData.sportIds.length === 0) {
        this.$message({
          message: "Must checked sport first",
          type: "warning"
        });
        return;
      }
      try {
        // 以前只传 sportIds，现在一起把 matchType 传给接口
        const params = {
          sportId: Array.isArray(this.marketQueryData.sportIds)
    ? String(this.marketQueryData.sportIds[0] ?? '')
    : String(this.marketQueryData.sportIds ?? ''), // 原来用的这个
          matchType: this.matchType || undefined   // 新增
        };
        const res = await getPeriodList(params);
        const data = res.data || [];
        this.periodList = data || [];
      } catch (error) {
        this.periodList = [];
      }
    },
    getSport(e) {
      this.queryData.sportIds = [];
      this.marketQueryData.sportIds = [];
      if (e !== "") {
        this.queryData.sportIds.push(e);
        this.marketQueryData.sportIds.push(e);
      }
    },
    deleteEmptyQuery(data) {
      return Object.entries(data)
        .filter(
          ([key, value]) => (value && value.length) || !Array.isArray(value)
        )
        .reduce((prev, [key, value]) => {
          prev[key] = value;
          return prev;
        }, {});
    },
    formatMoney(val) {
      if (!Number(val)) {
        return 0;
      }
      return Math.floor(Number(val) * 100) / 100;
    },
    feachOdds(val) {
      if (val == 1) {
        return "EU";
      } else if (val == 2) {
        return "HK";
      } else if (val == 3) {
        return "MY";
      } else if (val == 4) {
        return "IN";
      } else if (val == 5) {
        return "US";
      } else {
        return "EU";
      }
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changeOddsPage(e) {
      this.queryData.current = e;
      this.getOddsList();
    },
    // 列表显示条目
    handleSizeOddsChange(e) {
      this.oddsQueryData.size = e;
      this.oddsQueryData.current = 1;
      this.getOddsList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      //this.getList();
    },
    // 清空
    handleClear() {
      this.queryData = {
        ...this.queryData,
        ip: "",
        riskTagIds: [],
        userIds: [],
        orderStartTime: "",
        orderEndTime: "",
        seriesType: "",
        settleStartTime: "",
        settleEndTime: "",
        orderIds: [],
        orderStatus: [],
        sportIds: [],
        period: [],
        matchIds: [],
        marketTypes: [],
        result: [],
        timeZoneOffset: "",
        isInplay: "",
        current: 1,
        size: 50,
        promotionResult: "",
      };
      this.orderTime = [];
      this.settleTime = [];
      this.statusId = "";
      this.sportId = "";
      this.ordersId = "";
      this.matchsId = "";
      this.marketList = [];
    },
    handleExport() {
      this.queryData.timeZoneOffset = new Date().getTimezoneOffset();
      getExport(this.queryData, "export.xlsx");
    },
    // 弹窗
    showDialog(row, num, orderTime, item) {
      this.num = num;

      // cashout
      if (this.num == 1 && row.cashoutCount > 0) {
        this.cashoutCount = row.cashoutCount;
        this.cashoutQueryData.orderId = row.orderId;
        this.cashoutQueryData.orderStatus = row.status;
        this.getCashoutList();
        this.$refs["dialogDom"].isShowDia(this.title, true);
      } else if (this.num == 2) {
        // odds
        this.forwardAccessTime = 5;
        this.futureAccessTime = 5;
        this.oddsQueryData.odds = row ? row.betDetail[0].odds : item.odds;
        this.oddsQueryData.matchId = row
          ? row.betDetail[0].matchId
          : item.matchId;
        this.oddsQueryData.marketId = row
          ? row.betDetail[0].marketId
          : item.marketId;
        this.oddsQueryData.period = row ? row.betDetail[0].period : item.period;
        this.oddsQueryData.optionType = row
          ? row.betDetail[0].optionType
          : item.optionType;
        this.accessTime = orderTime;
        let endTime = this.$moment(Number(orderTime))
          .add(5, "m")
          .valueOf();
        this.oddsQueryData.endTime = endTime;
        let beginTime = this.$moment(Number(orderTime))
          .subtract(5, "m")
          .valueOf();
        this.oddsQueryData.beginTime = beginTime;
        this.getOddsList();
        this.$refs["dialogDom"].isShowDia(this.title, true, "1200px");
      }
    },
    isRed({ row }) {
      if (row.difference == 0) {
        return {
          backgroundColor: "#f8e6e5",
          color: "#e1554f"
        };
      }
    },
    handleForwardAccessTime() {
      this.forwardAccessTime = this.forwardAccessTime.replace(/\D/g, "");
      // 检查是否有前导零
      if (/^0+/.test(this.forwardAccessTime)) {
        this.forwardAccessTime = "";
      }
      if (this.forwardAccessTime !== "" && Number(this.forwardAccessTime) < 1) {
        this.forwardAccessTime = "";
      }
    },
    handleFutureAccessTime() {
      this.futureAccessTime = this.futureAccessTime.replace(/\D/g, "");
      // 检查是否有前导零
      if (/^0+/.test(this.futureAccessTime)) {
        this.futureAccessTime = "";
      }
      if (this.futureAccessTime !== "" && Number(this.futureAccessTime) < 1) {
        this.futureAccessTime = "";
      }
    },
    handleTimeClick(btnId) {
      const now = this.accessTime;
      let interval = 0;
      switch (btnId) {
        case "5":
          interval = 5 * 60 * 1000;
          break;
        case "15":
          interval = 15 * 60 * 1000;
          break;
        case "60":
          interval = 60 * 60 * 1000;
          break;
        default:
          break;
      }
      this.forwardAccessTime = btnId;
      const beginTime = now - interval;
      this.oddsQueryData.beginTime = beginTime;
      this.getOddsList();
    },
    moreOddsList() {
      const now = Number(this.accessTime);
      let beginTime = Number(this.forwardAccessTime) * 60 * 1000;
      let endTime = Number(this.futureAccessTime) * 60 * 1000;
      if (this.forwardAccessTime) {
        this.oddsQueryData.beginTime = now - beginTime;
      }
      if (this.futureAccessTime) {
        this.oddsQueryData.endTime = now + endTime;
      }
      this.getOddsList();
      // this.forwardAccessTime = "";
      // this.futureAccessTime = "";
    },
    async getOddsList() {
      this.dialogLoading = true;
      try {
        const res = await getOddsList(this.oddsQueryData);
        const data = res.data.records || {};
        this.oddsList = data || [];
        this.oddsTotal = Number(res.data.total);
        this.dialogLoading = false;
      } catch (error) {
        this.oddsList = [];
        this.dialogLoading = false;
      }
    },
    async getCashoutList() {
      this.dialogLoading = true;
      try {
        const res = await getCashoutList(this.cashoutQueryData);
        const data = res.data || {};
        this.cashoutList = data || [];
        this.dialogLoading = false;
      } catch (error) {
        this.cashoutList = [];
        this.dialogLoading = false;
      }
    },
    odds(maxWinAmount, stake, betNum) {
      return formatAmount(
        (Number(stake) + Number(maxWinAmount)) /
          (Number(stake) / Number(betNum))
      );
    },
    getAllSearch() {
      this.allSearchVisible = !this.allSearchVisible;
    }
  },
  components: {
    dia,
    Empty,
    eventList
  },
  mounted() {
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime() -
        30 * 24 * 60 * 60 * 1000,
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.orderTime = d;
    this.queryData.orderStartTime = d[0];
    this.queryData.orderEndTime = d[1];
    this.getList();
    this.getSportList();
    this.getRiskTagList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.table-search-part{
  .el-input{
    width: 150px !important;
  }
}
.more-search-part {
  border-bottom: 2px solid transparent !important;
}
.match {
  font-size: 10px;
  color: #999;
  .matchId {
    color: #666;
  }
  .home-away {
    font-size: 12px;
    color: #0184b8;
    cursor: pointer;
  }
}
.result {
  color: #999;
  .result-text {
    position: relative;
    font-weight: bold;
    span {
      display: inline-block;
      width: 7px;
      height: 7px;
      top: -3px;
      left: -4px;
      position: absolute;
      border-radius: 50%;
    }
  }
}
.region,
.ip {
  color: #999;
}
.dialog-odd-wrapper {
  position: relative;
}
.dialog-more {
  position: absolute;
  top: -48px;
  z-index: 999;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  .dialog-more-item {
    display: flex;
    align-items: center;
    /deep/.el-form-item__label {
      width: 130px !important;
    }
    /deep/.el-input {
      width: 70px !important;
      .el-input__inner {
        width: 60px !important;
      }
    }
  }
}

.select-btn {
  margin: 0 10px 0 0;
}
.order-search-left {
  width: 69% !important;
}
.order-search-right {
  width: 31% !important;
  .lebel-risk-export-btn {
    width: 90px;
    height: 30px;
    line-height: 30px !important;
    vertical-align: top;
  }
}
.ipStatus {
  color: #e1554f;
}
.el-table::before {
  height: 0 !important;
}
</style>
